import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getCardIcon,
  getCardIconType,
  getCardTitle,
  getCardValue,
  getChangeType,
  getSubLabel,
} from "../MemberReportMocks";
import CalendarLoader from "../../../common-components/CalendarLoader";

const MemberGymwiseStats = ({ onCardClick }) => {
  const { gymCardStats, gymCardStatsLoading, gymCardStatsError } = useSelector(
    (state) => state.prospects
  );

  const [statsData, setStatsData] = useState(null);

  useEffect(() => {
    if (!gymCardStatsLoading && !gymCardStatsError && gymCardStats?.status) {
      setStatsData(gymCardStats?.data);
    } else {
      setStatsData(null);
    }
  }, [gymCardStatsLoading, gymCardStatsError, gymCardStats]);

  return (
    <div className="mr-kpi-grid grid-5">
      {gymCardStatsLoading ? (
        <CalendarLoader daysCount={5} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, data]) => {
          const isTrainerAttendance = key === "trainer_attendance";
          const isBCAPending = key === "bca_pending";
          const isUnassigned = key === "unassigned";
          const isPtTrialPending = key === "pt_trial_pending";
          const isTotalCheckins = key === "total_checkins";
          const isPTTrialInProgress = key === "pt_trial_inprogress";
          const isPTTrialNotInitiated = key === "pt_trial_not_initiated";
          const isClickableCard =
            isTrainerAttendance ||
            isBCAPending ||
            isUnassigned ||
            isPtTrialPending ||
            isTotalCheckins ||
            isPTTrialInProgress ||
            isPTTrialNotInitiated;

          const getClickHandler = () => {
            if (!onCardClick) return undefined;

            if (isTrainerAttendance) {
              return () => {
                onCardClick("trainer_attendance");
              };
            }
            if (
              isBCAPending ||
              isUnassigned ||
              isPtTrialPending ||
              isPTTrialInProgress ||
              isPTTrialNotInitiated
            ) {
              return () => {
                onCardClick("member_detailed");
              };
            }
            if (isTotalCheckins) {
              return () => {
                onCardClick("member_attendance");
              };
            }
            return undefined;
          };

          const getTooltip = () => {
            if (!onCardClick) return "";

            if (isTrainerAttendance) {
              return "Click to view trainer attendance details";
            }
            if (
              isBCAPending ||
              isUnassigned ||
              isPtTrialPending ||
              isPTTrialInProgress ||
              isPTTrialNotInitiated
            ) {
              return "Click to view member details";
            }
            if (isTotalCheckins) {
              return "Click to view member attendance";
            }
            return "";
          };

          const getButtonText = () => {
            if (isTrainerAttendance) return "View Attendance";
            if (isBCAPending) return "View BCA Pending";
            if (isUnassigned) return "View Unassigned";
            if (
              isPtTrialPending ||
              isPTTrialInProgress ||
              isPTTrialNotInitiated
            )
              return "View Trial Pending";
            if (isTotalCheckins) return "View Check-ins";
            return "View Details";
          };

          const getButtonIcon = () => {
            return (
              <svg
                className="mr-kpi-action-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            );
          };

          return (
            <div
              className={`mr-kpi-card ${
                isClickableCard ? "mr-kpi-card--clickable" : ""
              }`}
              key={key}
              onClick={getClickHandler()}
              // style={{
              //   cursor:
              //     isClickableCard && getClickHandler() ? "pointer" : "default",
              // }}
              // title={getTooltip()}
            >
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{getCardTitle(key)}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">
                      {getCardValue(key, data)}
                    </div>
                    {data.change && (
                      <div
                        className={`mr-kpi-trend mr-kpi-trend--${getChangeType(
                          data.change_type
                        )}`}
                      >
                        {data.change}
                      </div>
                    )}
                  </div>

                  {key === "trainer_attendance" && (
                    <div
                      className="mr-kpi-subtitle"
                      style={{
                        color: key === "trainer_attendance" ? "#b91c1c" : "",
                      }}
                    >
                      {getSubLabel(key, data)}
                    </div>
                  )}
                </div>
                <span
                  className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(key)}`}
                >
                  {getCardIcon(key)}
                </span>
              </div>

              {isClickableCard && (
                <div className="mr-kpi-actions">
                  <button
                    className="mr-kpi-action-btn"
                    onClick={getClickHandler()}
                    title={getTooltip()}
                  >
                    {getButtonText()}
                    {getButtonIcon()}
                  </button>
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default MemberGymwiseStats;
